"use client";

import { useId, useState } from "react";

import { Collapsible } from "@/ui/components/data-display/Collapsible";
import {
  CALENDAR_PREVIEW_CLASS_MAP,
  CALENDAR_PREVIEW_DEFAULTS,
  type TCalendarPreviewProps,
} from "@/ui/components/form/Calendar/CalendarPreview.config";
import {
  CalendarPreviewHeader,
} from "@/ui/components/form/Calendar/CalendarPreviewHeader";
import {
  CalendarPreviewPanel,
} from "@/ui/components/form/Calendar/CalendarPreviewPanel";

export const CalendarPreview = ({
  calendar,
  closeLabel = CALENDAR_PREVIEW_DEFAULTS.closeLabel,
  date,
  defaultOpen = CALENDAR_PREVIEW_DEFAULTS.defaultOpen,
  editLabel = CALENDAR_PREVIEW_DEFAULTS.editLabel,
  id,
  title = CALENDAR_PREVIEW_DEFAULTS.title,
  hideDatePreview,
}: TCalendarPreviewProps) => {
  const generatedId = useId();
  const [ isOpen, setIsOpen ] = useState(defaultOpen);
  const calendarId = id ?? `calendar-preview-${generatedId}`;

  return (
    <Collapsible
      data-component="CalendarPreview"
      className={CALENDAR_PREVIEW_CLASS_MAP.root}
      forceMountContent
      open={isOpen}
      title={isOpen ? closeLabel : editLabel}
      triggerChildren={hideDatePreview ? undefined : (
        <CalendarPreviewHeader
          date={date}
          title={title}
        />
      )}
      triggerClassName={CALENDAR_PREVIEW_CLASS_MAP.header}
      variant="tertiary"
      onOpenChange={setIsOpen}
    >
      <CalendarPreviewPanel
        calendar={calendar}
        id={calendarId}
        isOpen={isOpen}
      />
    </Collapsible>
  );
};

CalendarPreview.displayName = "CalendarPreview";
